import { startCase } from "lodash";
import { findVariantPatchConflicts } from "./findVariantPatchConflicts";
import { VariantInformation } from "./isVariantInformation";

/**
 * Names a patch group using shared properties, or its own properties when independent.
 *
 * @param information - Named patch catalogue containing the group's operations
 * @param patchNames - Patches belonging to one connected overlap group
 * @returns A readable property list followed by changes, or No changes for empty patches
 */
export const getVariantPatchGroupName = (
  information: VariantInformation,
  patchNames: string[],
): string => {
  const conflicts = findVariantPatchConflicts(information, patchNames);
  const paths =
    conflicts.length > 0
      ? conflicts.map((conflict) =>
          conflict.firstPath.split("/").length <= conflict.secondPath.split("/").length
            ? conflict.firstPath
            : conflict.secondPath,
        )
      : patchNames.flatMap((name) =>
          (information.allVariantPatches[name] ?? []).map((operation) => operation.path),
        );
  const properties = paths.map((path) => {
    const tokens = path.split("/").slice(1);
    const property = tokens[0] === "body" ? (tokens[1] ?? "body") : (tokens[0] ?? "TLF");
    return startCase(property.replace(/~1/g, "/").replace(/~0/g, "~"));
  });
  const names = [...new Set(properties)];
  return names.length > 0
    ? `${new Intl.ListFormat("en-GB", { type: "conjunction" }).format(names)} changes`
    : "No changes";
};
